import { QueryKey, useQuery, UseQueryOptions } from 'react-query';

import { getSkillsDrawerList } from 'services/app';

export default function useSkillsDrawerList(
  companySlug: string,
  options?: Omit<UseQueryOptions<any, Error, any, QueryKey>, 'queryKey'>
) {
  return useQuery<any, Error>(
    `company-${companySlug}-skills-drawer-list`,
    () =>
      getSkillsDrawerList(companySlug).then((response) => {
        if (!response.ok) {
          throw new Error(response.originalError?.message);
        }

        return response.data;
      }),
    {
      ...options,
      cacheTime: 600000,
    }
  );
}
